var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLandingRightMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0632 3.938C17.9968 1.87641 15.1504 0.599609 12.0016 0.599609C8.85276 0.599609 6.00637 1.87641 3.93996 3.938C1.87836 6.0044 0.601562 8.8556 0.601562 11.9996C0.601562 18.2924 5.70877 23.3996 12.0016 23.3996C15.1504 23.3996 17.9968 22.1228 20.0632 20.0612C22.1248 17.9996 23.4016 15.1484 23.4016 11.9996C23.4016 8.85081 22.1248 6.0044 20.0632 3.938ZM12.0016 21.1196C6.97356 21.1196 2.88156 17.0276 2.88156 11.9996C2.88156 6.97161 6.97356 2.87961 12.0016 2.87961C17.0296 2.87961 21.1216 6.97161 21.1216 11.9996C21.1216 17.0276 17.0296 21.1196 12.0016 21.1196Z",
    fill: "#6A097D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.388 9.53499L10.8456 16.0774C10.5408 16.3822 10.0464 16.3822 9.74163 16.0774L6.61923 12.9574C6.31442 12.6502 6.31442 12.1558 6.61923 11.851L7.12803 11.3446C7.43283 11.0398 7.92723 11.0398 8.23202 11.3446L10.2936 13.4062L15.7728 7.92219C16.0776 7.61738 16.572 7.61499 16.8768 7.91978L17.388 8.42858C17.6928 8.73339 17.6952 9.22779 17.388 9.53499Z",
    fill: "#6A097D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandingRightMark);
export default __webpack_public_path__ + "static/media/landing-right-mark.37bede11c09d17f0961470e2835d2a7e.svg";
export { ForwardRef as ReactComponent };